import require$$0 from "vue";
var Vue = require$$0;
Vue = "default" in Vue ? Vue["default"] : Vue;
var version = "2.2.2";
var compatible = /^2\./.test(Vue.version);
if (!compatible) {
  Vue.util.warn("VueClickaway " + version + " only supports Vue 2.x, and does not support Vue " + Vue.version);
}
var HANDLER = "_vue_clickaway_handler";
function bind(el, binding, vnode) {
  unbind(el, binding);
  var vm = vnode.context;
  var callback = binding.value;
  if (typeof callback !== "function") {
    if (process.env.NODE_ENV !== "production") {
      Vue.util.warn(
        "v-" + binding.name + '="' + binding.expression + '" expects a function value, got ' + callback
      );
    }
    return;
  }
  var initialMacrotaskEnded = false;
  setTimeout(function() {
    initialMacrotaskEnded = true;
  }, 0);
  el[HANDLER] = function(ev) {
    var path = ev.path || (ev.composedPath ? ev.composedPath() : void 0);
    if (initialMacrotaskEnded && (path ? path.indexOf(el) < 0 : !el.contains(ev.target))) {
      return callback.call(vm, ev);
    }
  };
  if (binding.arg) {
    document.documentElement.addEventListener(binding.arg, el[HANDLER], false);
  } else {
    document.documentElement.addEventListener("click", el[HANDLER], false);
  }
}
function unbind(el, binding) {
  if (binding.arg) {
    document.documentElement.removeEventListener(binding.arg, el[HANDLER], false);
  } else {
    document.documentElement.removeEventListener("click", el[HANDLER], false);
  }
  delete el[HANDLER];
}
var directive = {
  bind,
  update: function(el, binding, vnode) {
    if (binding.value === binding.oldValue)
      return;
    bind(el, binding, vnode);
  },
  unbind
};
var directive_1 = directive;
export {
  directive_1 as directive
};
